export default __webpack_public_path__ + "static/media/resteo.bb1a57a2.png";